
(() => {
    angular.module('app', ['ngIntersectionObserver', 'screenSizer', 'ngTouch', 'lazyload', 'fileUpload', 'ngSelect', 'slideOutCardCtrl', 'tabs', 'inViewAnimate', 'modal', 'slideOutCard', 'loading', 'drawingTool', 'videoBox', "accordion", "map", 'cardAccordionApp']);
})();
